import { renderApiDomain } from "../helper/renderApiDomain";
import { get } from "../helper/request";

export const getAccountBenefit = async (platform) => {
  return get(`${renderApiDomain()}user/account/benefit`);
};
